import styled from 'styled-components';

export const MainContainer = styled.div`
  .ant-radio-group {
    margin-top: 8px;
    div:not(:last-child) {
      margin-bottom: 10px;
    }
  }
`;

export const TitleContainer = styled.div`
  display: flex;
  justify-content: space-between;
  .icon {
    margin-right: 0;
    cursor: pointer;
  }
`;

export const IconsContainer = styled.div`
  display: flex;
  div {
    cursor: pointer;
  }
`;
